import React from 'react';
import { Language, PDF_LANGUAGE_OPTIONS } from '../types/language';

interface DownloadLanguageModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (language: Language) => void;
  currentLanguage: Language;
  invoiceNumber: string;
}

export default function DownloadLanguageModal({ 
  isOpen, 
  onClose, 
  onConfirm, 
  currentLanguage, 
  invoiceNumber 
}: DownloadLanguageModalProps) {
  const [selectedLanguage, setSelectedLanguage] = React.useState<Language>(currentLanguage);
  
  // Обновляем выбранный язык при изменении currentLanguage
  React.useEffect(() => {
    setSelectedLanguage(currentLanguage);
  }, [currentLanguage]);

  const handleConfirm = () => {
    onConfirm(selectedLanguage);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-96 max-w-md mx-4">
        <h3 className="text-lg font-semibold mb-4">
          Wybierz język dla faktury
        </h3>
        
        <div className="mb-4">
          <p className="text-sm text-gray-600 mb-2">
            Faktura: <span className="font-medium">{invoiceNumber}</span>
          </p>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Język PDF:
          </label>
          <select
            value={selectedLanguage}
            onChange={(e) => setSelectedLanguage(e.target.value as Language)}
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md text-sm bg-white hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors"
          >
            {PDF_LANGUAGE_OPTIONS.map((option) => (
              <option key={option.code} value={option.code}>
                {option.nativeName}
              </option>
            ))}
          </select>
        </div>

        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Anuluj
          </button>
          <button
            onClick={handleConfirm}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Pobierz PDF
          </button>
        </div>
      </div>
    </div>
  );
}
